import { gql } from '@common/hooks';

export const ACTIVE_SYSTEM_MESSAGE_BANNERS_QUERY = gql`
  query ActiveSystemMessageBannersQuery {
    activeSystemMessageBanners {
      id
      body
    }
  }
`;

export type ActiveSystemMessageBannersQueryResponse = {
  activeSystemMessageBanners: {
    id: string;
    body: string;
  }[];
};
